import { RouteConfig } from 'vue-router';

import ProfileEdit from '@/views/profile/Edit.vue';

export function profileEditRoute(name: string): RouteConfig {
  return {
    path: 'edit',
    name,
    component: ProfileEdit,
    props: { edit: true },
    meta: {
      title: 'titles.profile.edit'
    }
  };
}
